export default __webpack_public_path__ + "static/media/1422_1424.997d945b.JPG";